<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import {
  getInformationInfos,
  deleteInformationInfos,
  issueInformationInfos,
  dropInformationInfos
} from '@/api/informationInfos.js'

export default {
  mixins: [mixinsBackStack, makeFakerData],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      tableValue: [],
      defaultSearchParam: {},
      defaultValue: {},
      utilsBtnList: [
        { name: '新增', cb: 'createFinance' },
        { name: '发布', cb: 'issue' },
        { name: '下架', cb: 'drop' },
        { name: '删除', cb: 'batchDelete' }
      ]
    }
  },
  components: {
    Table,
    Form,
    AModal,
    TableToolsWrap
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        const params = this.handlerBeforeRequestParams()
        const { rows, total } = await getInformationInfos(params) // 请求表格数据接口
        const row = this.handlerDateFormat(rows) // 处理时间格式
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...this.searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    createFinance() {
      this.$router.push({ name: 'informationCreate' })
    },
    // 前往详情
    toDetail(row) {
      const { id } = row.scope
      this.$router.push({
        name: 'informationCreate',
        query: { type: 'detail', id }
      })
    },
    // 编辑
    edit(row) {
      const forbidden = ['1']
      const check = forbidden.includes(row.status)
      if (check) {
        return this.$apiStatusHandler(999, '只有待发布的综合信息允许编辑')
      }
      this.$router.push({
        name: 'informationCreate',
        query: { type: 'edit', id: row.id }
      })
    },
    // 发布
    issue() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的综合信息')
      }
      this.customModalOpt.contentTips = '是否确定发布该内容'
      this.beforeShowModal(true, {
        source: 'dealIssueApi',
        params: { items: selectedIds }
      })
    },
    // 调用发布接口
    async dealIssueApi(params) {
      const { items } = params
      const forbidden = ['1']
      const check = items.filter(item => forbidden.includes(item.status))
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的综合信息允许发布')
      }
      try {
        const ids = items.map(item => item.id)
        const { msg, code } = await issueInformationInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 下架
    drop() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const forbidden = ['0']
      const check = selectedIds.filter(item => forbidden.includes(item.status))
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有已发布的综合信息允许下架')
      }
      const idstatus = selectedIds.map(item => item.id)
      this.customModalOpt.contentTips = '是否确定下架已选的综合信息'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的综合信息')
      }
      this.beforeShowModal(true, {
        source: 'dealDropApi',
        params: { ids: idstatus }
      })
    },
    // 调用下架接口
    async dealDropApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await dropInformationInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 单独删除
    singleDelete(row) {
      if (row.status === '1') {
        return this.$apiStatusHandler(999, '只有未发布的综合信息允许删除')
      }
      this.customModalOpt.contentTips = '是否确定删除该内容'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 批量删除
    batchDelete() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const idstatus = selectedIds.map(item => item.id)
      const forbidden = ['1']
      const ids = this.$refs.table.selectedRowIds
      const check = ids.filter(item => forbidden.includes(item.status))
      if (check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的综合信息允许删除')
      }
      this.customModalOpt.contentTips = '是否确定删除已选的综合信息'
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的综合信息')
      }
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: idstatus }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteInformationInfos(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    }
  }
}
</script>
